import request from '@/utils/request'
export function findFileById(data) {
    return request({
        method: 'post',
        url: '/pzFile/findById.do',
        data: data
    })
}
// 查询反馈问题列表
export function feedbackQuestionQuery(data) {
    return request({
        method: 'post',
        url: '/feedbackQuestion/queryByInspectionOid.do',
        data: data,
        loading: true
    })
}
export function feedbackQuestionSave(data) {
    return request({
        method: 'post',
        url: '/feedbackQuestion/add.do',
        data: data,
        loading: true
    })
}
export function feedbackQuestionUpdate(data) {
    return request({
        method: 'post',
        url: '/feedbackQuestion/update.do',
        data: data,
        loading: true
    })
}
export function feedbackQuestionUpdate2(data) {
    return request({
        method: 'post',
        url: 'feedbackQuestion/updateCustomById.do',
        data: data,
        loading: true
    })
}
export function feedbackQuestionDel(data) {
    return request({
        method: 'post',
        url: '/feedbackQuestion/deleteById.do',
        data: data,
        loading: true
    })
}
export function feedbackQueryById(data) {
    return request({
        method: 'post',
        url: '/feedbackQuestion/queryById.do',
        data: data,
        loading: true
    })
}
// 省委巡视获取列表
export function showListSW(data) {
    return request({
        method: 'post',
        url: '/inspection/showTotal.do',
        data: data,
        loading: true
    })
}
// 获取列表
export function showList(data) {
    return request({
        method: 'post',
        url: '/zyInspection/showTotal.do',
        data: data,
        loading: true
    })
}
// 整改督察根据当前阶段查询浙江反馈一行的数据
export function countNum(data) {
    return request({
        method: 'post',
        url: '/zyInspection/countNum.do',
        data: data,
        loading: true
    })
}
// 新增整改方案 保存按钮
export function inspectionAdd(data) {
    return request({
        method: 'post',
        url: '/inspection/add.do',
        data: data,
        loading: true
    })
}
// 查询填报内容
export function queryContentByRfId(data) {
    return request({
        method: 'post',
        url: 'zyInspection/queryContentByRfId.do',
        data: data,
        loading: true
    })
}
// 一级列表 修改
export function inspectionSave(data) {
    return request({
        method: 'post',
        url: '/inspection/save.do',
        data: data,
        loading: true
    })
}
// 导入弹框 保存 新增 /rectification/add.do
export function rectificationAdd(data) {
    return request({
        method: 'post',
        url: '/rectification/save.do',
        data: data,
        loading: true
    })
}
export function qdQueryById(data) {
    return request({
        method: 'post',
        url: 'fourList/queryById.do',
        data: data,
        loading: true
    })
}
// 保存
export function rectificationSave(data) {
    return request({
        method: 'post',
        url: '/rectification/save.do',
        data: data,
        loading: true
    })
}
// 修改整改措施
export function rectificationSave2(data) {
    return request({
        method: 'post',
        url: '/rectification/updateByRectificationId.do',
        data: data,
        loading: true
    })
}
//
export function deleteInspectionById(data) {
    return request({
        method: 'post',
        url: '/inspection/deleteInspectionById.do',
        data: data,
        loading: true
    })
}

export function questionDeleteById(data) {
    return request({
        method: 'post',
        url: '/question/deleteById.do',
        data: data,
        loading: true
    })
}
// 问题保存
export function questionSave(data) {
    return request({
        method: 'post',
        url: '/question/save.do',
        data: data,
        loading: true
    })
}
// 两报告
// 两报告 删除
export function deleteReportById(data) {
    return request({
        method: 'post',
        url: '/SelfAssessmentReport/deleteReportById.do',
        data: data,
        loading: true
    })
}
// 列表查询
export function reportQuery(data) {
    return request({
        method: 'post',
        url: '/SelfAssessmentReport/query.do',
        data: data,
        loading: true
    })
}
// 新增自评报告
export function reportAdd(data) {
    return request({
        method: 'post',
        url: '/SelfAssessmentReport/add.do',
        data: data,
        loading: true
    })
}
// 自评人员查询
export function findReportById(data) {
    return request({
        method: 'post',
        url: '/SelfAssessmentReport/findReportById.do',
        data: data,
        loading: true
    })
}
// 两报告
// 廉情人员查询
export function LqFindReportById(data) {
    return request({
        method: 'post',
        url: '/LqReport/findReportById.do',
        data: data,
        loading: true
    })
}
// 廉情修改
export function LqUpdate(data) {
    return request({
        method: 'post',
        url: '/LqReport/update.do',
        data: data,
        loading: true
    })
}
// 自评报告修改
export function zpUpdate(data) {
    return request({
        method: 'post',
        url: '/SelfAssessmentReport/update.do',
        data: data,
        loading: true
    })
}
// 新增廉政报告
export function LqAdd(data) {
    return request({
        method: 'post',
        url: '/LqReport/add.do',
        data: data,
        loading: true
    })
}
// 廉情列表查询
export function LqQuery(data) {
    return request({
        method: 'post',
        url: '/LqReport/query.do',
        data: data,
        loading: true
    })
}
// 廉情删除
export function LqDeleteReportById(data) {
    return request({
        method: 'post',
        url: '/LqReport/deleteReportById.do',
        data: data,
        loading: true
    })
}
// 四清单
export function fourListShowList(data) {
    return request({
        method: 'post',
        url: '/fourList/showList.do',
        data: data,
        loading: true
    })
}
// 四清单 修改
export function fourListSave(data) {
    return request({
        method: 'post',
        url: '/fourList/save2.do',
        data: data,
        loading: true
    })
}
//  细表删除
export function deleteFourListDetailedById(data) {
    return request({
        method: 'post',
        url: '/fourListDetailed/deleteFourListDetailedById.do',
        data: data,
        loading: true
    })
}
export function addFourListDetailed(data) {
    return request({
        method: 'post',
        url: '/fourList/add.do',
        data: data,
        loading: true
    })
}
// 四清单列表删除
export function deleteFourListById(data) {
    return request({
        method: 'post',
        url: '/fourList/deleteFourListById.do',
        data: data,
        loading: true
    })
}
export function saveFourList(data) {
    return request({
        method: 'post',
        url: '/fourListDetailed/save.do',
        data: data,
        loading: true
    })
}
export function hyregister(data) {
    return request({
        method: 'post',
        url: '/LzPerson/register.do',
        data: data,
        loading: true
    })
}
// 新增问题 一级
export function questionAdd(data) {
    return request({
        method: 'post',
        url: '/question/add.do',
        data: data,
        loading: true
    })
}
// 提交审批
export function Candidates(data) {
    return request({
        method: 'post',
        url: '/question/submitForApproval.do',
        data: data,
        loading: true
    })
}
// 提交审批
export function Submitted(data) {
    return request({
        method: 'post',
        url: '/question/submitAllForApproval.do',
        data: data,
        loading: true
    })
}
// 整改情况措施 通过不同过
export function throughout(data) {
    return request({
        method: 'post',
        url: '/rectification/updateRectificationById.do',
        data: data,
        loading: true
    })
}
// 整改情况通过不通过
export function breakthrough(data) {
    return request({
        method: 'post',
        url: '/rectificationSituation/updateRectificationSituationById.do',
        data: data,
        loading: true
    })
}
// 根据questionOid（问题id）查询整改内容集合
export function queryQuestionById(data) {
    return request({
        method: 'post',
        url: '/question/queryById.do',
        data: data,
        loading: true
    });
}

// 根据questionOid（问题id）查询整改内容集合
export function queryByProblemOId(data) {
    return request({
        method: 'post',
        url: '/rectificationSituation/queryByProblemOId.do',
        data: data,
        loading: true
    });
}

// 根据questionOid（问题id）查询整改措施集合
export function queryByInspectionId(data) {
    return request({
        method: 'post',
        url: '/rectification/queryByQuestionOId.do',
        data: data,
        loading: true
    });
}

// 查询巡视下的所有问题
export function QuestionList(data) {
    return request({
        method: 'post',
        url: '/question/queryByInspectionId.do',
        data: data,
        loading: true
    })
}

// 查询巡视下的所有问题
export function showQuestionList(data) {
    return request({
        method: 'post',
        url: '/question/queryByInspectionId.do',
        data: data,
        loading: true
    })
}
// 删除问题
export function delQuestionById(data) {
    return request({
        method: 'post',
        url: '/question/deleteById.do',
        data: data,
        loading: true
    })
}
// 一级列表修改
// export function saveFourList(data) {
//   return request({
//   method: 'post',
//   url: '/fourListDetailed/save.do',
//   data: data,
//   loading: true
// })
// }
// 整改情况保存
export function saveCondition(data) {
    return request({
        method: 'post',
        url: '/rectificationSituation/save.do',
        data: data,
        loading: true
    })
}
// 情况删除
export function rectificationDeleteById(data) {
    return request({
        method: 'post',
        // url: '/rectificationSituation/rectificationDeleteById',
        url: '/rectificationSituation/deleteById.do',
        data: data,
        loading: true
    })
}
// 措施删除
export function rectificationdel(data) {
    return request({
        method: 'post',
        // url: '/rectificationSituation/rectificationDeleteById',
        url: '/rectification/deleteById.do',
        data: data,
        loading: true
    })
}
// 整改措施历史审批记录
export function queryRectificationLog(data) {
    return request({
        method: 'post',
        url: '/question/queryRectificationLog.do',
        data: data,
        loading: true
    })
}
// 整改情况历史审批记录
export function queryRectificationSituationLog(data) {
    return request({
        method: 'post',
        url: '/question/queryRectificationSituationLog.do',
        data: data,
        loading: true
    })
}
// 问题存档
export function libarchive(data) {
    return request({
        method: 'post',
        url: '/question/saveArchives.do',
        data: data,
        loading: true
    })
}
// 整改情况通过
export function passSituation(data) {
    return request({
        method: 'post',
        url: '/question/rectificationSituationApproval.do',
        data: data,
        loading: true
    })
}
// 整改措施通过
export function passMeasure(data) {
    return request({
        method: 'post',
        url: '/question/rectificationApproval.do',
        data: data,
        loading: true
    })
}
// 新增巡视导入
export function tourImport(data) {
    return request({
        method: 'post',
        url: '/inspection/importQuestionExcel.do',
        data: data,
        loading: true
    })
}
// 档案授权管理单位列表
export function unitList(data) {
    return request({
        method: 'post',
        url: '/branchDept/queryLzBranchByOrgInnerCode.do',
        data: data,
        loading: true
    })
}
// 档案授权管理人员信息
export function personalInformation(data) {
    return request({
        method: 'post',
        url: '/branchDept/queryAllLzPersonInfoByBranchDeptId.do',
        data: data,
        loading: true
    })
}
// 授权状态保存
export function impowerSave(data) {
    return request({
        method: 'post',
        url: '/LzPerson/updateEmployee.do',
        data: data,
        loading: true
    })
}
// 问题底稿列表查询
export function patrolQuery(data) {
    return request({
        method: 'post',
        url: '/inspectionReport/query.do',
        data: data,
        loading: true
    })
}
// 问题底稿新增报告
export function addReport(data) {
  return request({
    method: 'post',
    url: '/inspectionReport/save.do',
    data: data,
    loading: true
  })
}
// 问题底稿删除
export function deleteReport(data) {
  return request({
    method: 'post',
    url: '/inspectionReport/deleteById.do',
    data: data,
    loading: true
  })
}
// 班子成员修改获取列表
export function materialQuery(data) {
  return request({
    method: 'post',
    url: '/accessRecords/query.do',
    data: data,
    loading: true
  })
}
// 班子成员修改报告新增
export function materialAdd(data) {
  return request({
    method: 'post',
    url: '/accessRecords/save.do',
    data: data,
    loading: true
  })
}
// 班子成员修改报告删除
export function materialUpd(data) {
  return request({
    method: 'post',
    url: '/accessRecords/deleteById.do',
    data: data,
    loading: true
  })
}
// 录入民主生活会
export function meetAdd(data) {
  return request({
    method: 'post',
    url: '/democraticLife/save.do',
    data: data,
    loading: true
  })
}

// 四清单问题分类编号
export function classifyCode(data) {
    return request({
        method: 'post',
        url: '/fourList/queryNumByLzInnerCode.do',
        data: data,
        loading: true
    })
}

// 查询民主生活会列表
export function queryLifeList(data) {
    return request({
        method: 'post',
        url: '/democraticLife/query.do',
        data: data,
        loading: true
    })
}

// 根据廉政部门编码查询档案信息
export function queryAllPerson(data) {
    return request({
        method: 'post',
        url: '/LzPerson/queryAllPerson.do',
        data: data,
        loading: true
    })
}

// 新增民主生活会列表项
export function newLifeItem(data) {
    return request({
        method: 'post',
        url: '/democraticLife/save.do',
        data: data,
        loading: true
    })
}

// 修改民主生活会列表项
export function putLifeItem(data) {
    return request({
        method: 'post',
        url: '/democraticLife/save.do',
        data: data,
        loading: true
    })
}

// 删除民主生活会列表项
export function deleteLifeItem(data) {
    return request({
        method: 'post',
        url: '/democraticLife/deleteById.do',
        data: data,
        loading: true
    })
}

// 根据姓名查询档案
export function deployQuery(data) {
    return request({
        method: 'post',
        url: 'LzPerson/queryPersonByName.do',
        data: data,
        loading: true
    })
}

// 查询信访列表
export function queryPetition(data) {
    return request({
        method: 'post',
        url: '/petitionInfo/query.do',
        data: data,
        loading: true
    })
}

// 新增修改信访列表
export function savePetition(data) {
    return request({
        method: 'post',
        url: '/petitionInfo/save.do',
        data: data,
        loading: true
    })
}

// 删除信访列表
export function deletePetition(data) {
    return request({
        method: 'post',
        url: '/petitionInfo/deleteById.do',
        data: data,
        loading: true
    })
}

// 新增修改党风廉政记录
export function savePartyStyle(data) {
    return request({
        method: 'post',
        url: '/commonsReply/save.do',
        data: data,
        loading: true
    });
}


// 删除党风廉政记录
export function delPartyStyle(data) {
    return request({
        method: 'post',
        url: '/commonsReply/deleteById.do',
        data: data,
        loading: true
    });
}

// 查询党风廉政记录
export function queryPartyStyle(data) {
    return request({
        method: 'post',
        url: '/commonsReply/queryList.do',
        data: data,
        loading: true
    });
}

// 巡视导出excell
export function exportExcell(data) {
    return request({
        method: 'post',
        url: '/inspection/exportExcel.do',
        data: data,
        loading: true
    });
}

// 发送-签收-退回
export function acceptQuestionStatus(data) {
    return request({
        method: 'post',
        url: '/question/acceptQuestionStatus.do',
        data: data,
        loading: true
    });
}

// 底稿调阅  **** 页面接口

// 底稿调阅查询审批或未审批的
export function queryManuscriptList(data) {
    return request({
        method: 'post',
        url: '/manuscriptAccess/queryByStatus.do',
        data: data,
        loading: true
    });
}

// 底稿调阅审批
export function approval(data) {
    return request({
        method: 'post',
        url: '/manuscriptAccess/approval.do',
        data: data,
        loading: true
    });
}

// 底稿调阅申请
export function manuscriptAccesSave(data) {
    return request({
        method: 'post',
        url: '/manuscriptAccess/save.do',
        data: data,
        loading: true
    });
}

// 底稿调阅点击查看按钮查询附件信息
export function queryByMaterialId(data) {
    return request({
        method: 'post',
        url: '/manuscriptAccess/queryByMaterialId.do',
        data: data,
        loading: true
    });
}


// 查询问题下的整改措施or情况历史记录
export function queryQuestionLog(data) {
    return request({
        method: 'post',
        url: '/question/queryQuestionLog.do',
        data: data,
        loading: true
    });
}

// 启动
export function changeStatus(data) {
    return request({
        method: 'post',
        url: '/zyInspection/changeStatus.do',
        data: data,
        loading: true
    });
}

// 上报
export function insertUpReport(data) {
    return request({
        method: 'post',
        url: '/upReport/insertUpReport.do',
        data: data,
        loading: true
    });
}
// 修改
export function updateContentByRfId(data) {
    return request({
        method: 'post',
        url: '/zyInspection/updateContentByRfId.do',
        data: data,
        loading: true
    });
}

// 历史记录
export function queryByHistory(data) {
    return request({
        method: 'post',
        url: '/upReport/queryByHistory.do',
        data: data,
        loading: true
    });
}

// 导出Excel
export function zyInspectionExportXsExcel(data) {
    return request({
        method: 'post',
        url: '/zyInspection/exportXsExcel.do',
        data: data,
        loading: true
    });
}

// 启动整改发送
export function sendRect(data) {
    return request({
        method: 'post',
        url: '/inspection/changeStatus.do',
        data: data,
        loading: true
    });
}
// 上报修改时间接口
export function changeUpTime(data) {
    return request({
        method: 'post',
        url: '/inspection/changeUpTime.do',
        data: data,
        loading: true
    });
}
// //启动整改发送测试接口
// export function sendRect1(data) {
//     return request({
//         method: 'post',
//         url: 'inspection/changeStatusTest.do',
//         data,
//         loading: true,
//     });
// }

// 列表查询 整改方案的问题及措施
export function queryInspectionById(data) {
    return request({
        method: 'post',
        url: '/inspection/queryInspectionById.do',
        data: data,
        loading: true
    });
}

// 根据左侧树查列表
export function queryInspectionAll(data) {
  return request({
      method: 'post',
      url: 'inspection/queryInspectionAll.do',
      data: data,
      loading: true
  });
}
// 上面的巡视信息
export function queryById(data) {
  return request({
      method: 'post',
      url: 'inspection/queryById.do',
      data: data,
      loading: true
  });
}
// 整改方案的问题及措施
// export function queryInspectionById(data) {
//   return request({
//       method: 'post',
//       url: 'inspection/queryInspectionById.do',
//       data: data,
//       loading: true,
//   });
// }
// 统计数据
export function countInspectionById(data) {
  return request({
      method: 'post',
      url: '/inspection/countInspectionById.do',
      data: data,
      loading: true
  });
}
// 新建问题
export function addQuestion(data) {
    return request({
        method: 'post',
        url: '/question/add.do',
        data: data,
        loading: true
    });
}

// 删除整改措施
export function rectificationDeleteById1(data) {
    return request({
        method: 'post',
        url: '/rectification/deleteById.do',
        data: data,
        loading: true
    });
}

// 查询整改措施
export function rectificationQueryById(data) {
    return request({
        method: 'post',
        url: '/rectification/queryById.do',
        data: data,
        loading: true
    });
}
// 填写审核意见
export function auditInspectionById(data) {
    return request({
        method: 'post',
        url: 'inspection/auditInspectionById.do',
        data: data,
        loading: true
    });
}
// 整改方案的填报old
export function saveReport(data) {
    return request({
        method: 'post',
        url: 'rectification/saveReport.do',
        data: data,
        loading: true
    });
}
// 查看审核意见
export function queryAuditOpinion(data) {
    return request({
        method: 'post',
        url: 'inspection/queryAuditOpinion.do',
        data: data,
        loading: true
    });
}
// 查询整改方案审核的角标
export function queryAuditNum(data) {
    return request({
        method: 'post',
        url: 'inspection/queryAudit.do',
        data: data,
        loading: true
    });
}

// 启动、完成按钮接口
export function rectificationChangeStatus(data) {
    return request({
        method: 'post',
        url: 'rectification/changeStatus.do',
        data: data,
        loading: true
    });
}
// 填报接口new
export function rectificationSituationSaveReport(data) {
    return request({
        method: 'post',
        url: 'rectificationSituation/saveReport.do',
        data: data,
        loading: true
    });
}

// 上报接口
export function rectificationSituationUpAuditByRectificationId(data) {
    return request({
        method: 'post',
        url: 'rectificationSituation/upAuditByRectificationId.do',
        data: data,
        loading: true
    });
}
// 上报接口
export function upAuditRfstByQuestionId(data) {
    return request({
        method: 'post',
        url: 'rectificationSituation/upAuditRfstByQuestionId.do',
        data: data,
        loading: true
    });
}

// 历史接口
export function rectificationSituationQueryByRectificationId(data) {
    return request({
        method: 'post',
        url: 'rectificationSituation/queryByRectificationId.do',
        data: data,
        loading: true
    });
}

// 审核接口
export function rectificationSituationAuditInspectionById(data) {
    return request({
        method: 'post',
        url: 'rectificationSituation/auditInspectionById.do',
        data: data,
        loading: true
    });
}

// 管辖关系新增修改保存接口
export function jurisdictionSave(data) {
    return request({
        method: 'post',
        url: '/branchAboral/save.do',
        data: data,
        loading: true
    });
}

// 审核历史查询接口new
export function rectificationQueryByRectificationId(data) {
    return request({
        method: 'post',
        url: 'rectification/queryByRectificationId.do',
        data: data,
        loading: true
    });
}

// 管辖关系查询接口
export function jurisdictionList(data) {
    return request({
        method: 'post',
        url: '/branchAboral/queryAll.do',
        data: data,
        loading: true
    });
}

// 批量通过/批量不通过
export function rectificationAuditRectificationByIdList(data) {
    return request({
        method: 'post',
        url: 'rectification/auditRectificationByIdList.do',
        data: data,
        loading: true
    });
}

// 管辖关系删除接口
export function jurisdictionDelete(data) {
    return request({
        method: 'post',
        url: '/branchAboral/deleteById.do',
        data: data,
        loading: true
    });
}

// 审核意见/审核通过/审核不通过
export function sendBatchAuditById(data) {
    return request({
        method: 'post',
        url: 'sendBatch/auditById.do',
        data: data,
        loading: true
    });
}

// 新建呈批按钮使用(整改方案)
export function rectificationQueryListByIdsStart(data) {
  return request({
    method: 'post',
    url: 'sendBatch/queryListByIdsStart.do',
    data: data,
    loading: true
  });
}

// 新建呈批按钮使用
export function sendBatchQueryListByIds(data) {
    return request({
        method: 'post',
        url: 'sendBatch/queryListByIds.do',
        data: data,
        loading: true
    });
}
// 查询巡视呈批详情
export function sendBatchQueryBatchDetailById(params) {
    return request({
        method: 'post',
        url: 'sendBatch/queryBatchDetailById.do',
        params: params,
        loading: true
    });
}
// （审签单保存）新建呈批表
export function sendBatchRegisterFormOpinion(data) {
    return request({
        method: 'post',
        url: 'sendBatch/registerFormOpinion.do',
        data: data,
        loading: true
    });
}
// （发送更新调用）修改呈批表
export function sendBatchUpdateFormOpinion(data) {
    return request({
        method: 'post',
        url: 'sendBatch/updateFormOpinion.do',
        data: data,
        loading: true
    });
}
// 签收呈批表
export function sendBatchUpdateSign(data) {
    return request({
        method: 'post',
        url: 'sendBatch/updateSign.do',
        data: data,
        loading: true
    });
}
// 查询呈批发送列表呈批表
export function sendBatchQuerySendGroup(data) {
    return request({
        method: 'post',
        url: 'sendBatch/querySendGroup.do',
        data: data,
        loading: true
    });
}
// 查询呈批发送列表的用户
export function sendBatchQuerySendPersons(data) {
    return request({
        method: 'post',
        url: 'sendBatch/querySendPersons.do',
        data: data,
        loading: true
    });
}

// 这个查询接口查询新建的呈批
export function sendBatchQueryBatchList(data) {
    return request({
        method: 'post',
        url: 'sendBatch/queryBatchList.do',
        data: data,
        loading: true
    });
}
// 呈批结束和承办人办理查询
export function sendBatchQueryCreatePersons(data) {
    return request({
        method: 'post',
        url: 'sendBatch/queryCreatePersons.do',
        data: data,
        loading: true
    });
}
// 保存修改问题统计表1
export function saveInspectionFeedback1(data) {
    return request({
        method: 'post',
        url: 'clueCount/saveCountFirst.do',
        data: data,
        loading: true
    });
}
// 根据巡视id,查询问题统计表1
export function queryInspectionFeedback1(data) {
    return request({
        method: 'post',
        url: 'clueCount/queryCountFirstByInspectionId.do',
        data: data,
        loading: true
    });
}
// 根据id,删除问题统计表1
export function deleteIdFeedback1(data) {
    return request({
        method: 'post',
        url: 'clueCount/deleteCountFirstById.do',
        data: data,
        loading: true
    });
}
// 根据巡视id,删除问题统计表1
export function deleteInspectionIdFeedback1(data) {
    return request({
        method: 'post',
        url: 'clueCount/deleteCountFirstByInspectionId.do',
        data: data,
        loading: true
    });
}
// 保存修改问题统计表2
export function saveInspectionFeedback2(data) {
    return request({
        method: 'post',
        url: 'clueCount/saveCountSecond.do',
        data: data,
        loading: true
    });
}
// 根据巡视id,查询问题统计表2
export function queryInspectionFeedback2(data) {
    return request({
        method: 'post',
        url: 'clueCount/queryCountSecondByInspectionId.do',
        data: data,
        loading: true
    });
}
// 根据id,删除问题统计表2
export function deleteIdFeedback2(data) {
    return request({
        method: 'post',
        url: 'clueCount/deleteCountSecondById.do',
        data: data,
        loading: true
    });
}
// 根据巡视id,删除问题统计表2
export function deleteInspectionIdFeedback2(data) {
    return request({
        method: 'post',
        url: 'clueCount/deleteCountSecondByInspectionId.do',
        data: data,
        loading: true
    });
}
// 呈批流转历史
export function sendBatchQueryLogByBatchId(data) {
    return request({
        method: 'post',
        url: 'sendBatch/queryLogByBatchId.do',
        data: data,
        loading: true
    });
}

// 整改情况上报--整改报告弹窗--保存接口
export function rectificationSituationReportSaveReport(data) {
    return request({
        method: 'post',
        url: 'rectificationSituationReport/saveReport.do',
        data: data,
        loading: true
    });
}

// 巡视反馈意见表、整改报告--查询接口
export function queryReportByUpAuditId(data) {
    return request({
        method: 'post',
        url: 'sendBatch/queryReportByUpAuditId.do',
        data: data,
        loading: true
    });
}

// 整改报告弹窗--查询接口
export function reportQueryByInspectionOid(data) {
    return request({
        method: 'post',
        url: 'rectificationSituationReport/queryByInspectionOid.do',
        data: data,
        loading: true
    });
}
// 整改情况上报--生成整改报告按钮接口
export function inspectionExportXsWord(data) {
    return request({
        method: 'post',
        url: '/inspection/exportXsWord.do',
        data: data,
        loading: true
    });
}
// 整改方案--生成整改方案按钮接口
export function inspectionExportXsProgrammeWord(data) {
    return request({
        method: 'post',
        url: '/inspection/exportXsProgrammeWord.do',
        data: data,
        loading: true
    });
}

// 整改报告审核--附件删除接口
export function pzFileDeleteByFileId(data) {
    return request({
        method: 'post',
        url: '/pzFile/deleteByFileId.do',
        data: data,
        loading: true
    });
}
// 点击届次统计表2查询
export function queryCountSecondAllByInspection(data) {
  return request({
      method: 'post',
      url: 'clueCount/queryCountSecondAllByInspection.do',
      data: data,
      loading: true
  });
}
// 点击届次统计表1查询
export function queryCountFirstAllByInspection(data) {
  return request({
      method: 'post',
      url: 'clueCount/queryCountFirstAllByInspection.do',
      data: data,
      loading: true
  });
}
// 业务部门查询巡视反馈意见整改处置情况汇总表一
export function queryCountFirstByUpAuditId(params) {
    return request({
        method: 'post',
        url: 'rectificationSituationReport/queryCountFirstByUpAuditId.do',
        params: params,
        loading: true
    });
}
// 业务部门查询巡视反馈意见整改处置情况汇总表二
export function queryCountSecondByUpAuditId(params) {
    return request({
        method: 'post',
        url: 'rectificationSituationReport/queryCountSecondByUpAuditId.do',
        params: params,
        loading: true
    });
}
// 审核意见的接口
export function sendBatchAuditReportEnd(data) {
  return request({
    method: 'post',
    url: '/sendBatch/auditReportEnd.do',
    data: data,
    loading: true
  });
}

// 整改情况直接审核通过
export function sendBatchDirectStatus(data) {
    return request({
      method: 'post',
      url: '/inspection/directStatus.do',
      data: data,
      loading: true
    });
  }
// 巡视巡查页面--整改方案的待办已办查询
export function rectificationQueryAudit(data) {
    return request({
      method: 'post',
      url: 'rectification/queryAudit.do',
      data: data,
      loading: true
    });
  }
  // 巡视巡查页面--整改情况的待办已办查询
export function rectificationSituationQueryAudit(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/queryAudit.do',
      data: data,
      loading: true
    });
  }
 // 新建呈批单，附件查询接口
 export function pzFileFindByParentId(data) {
    return request({
      method: 'post',
      url: 'pzFile/findByParentId.do',
      data: data,
      loading: true
    });
  }
  export function findByIdAndType(data) {
    return request({
      method: 'post',
      url: 'pzFile/findByIdAndType.do',
      data: data,
      loading: true
    });
  }
   // 巡视反馈意见整改处置情况汇总表一----导出
 export function inspectionExportWordExcel(data) {
    return request({
      method: 'post',
      url: 'inspection/exportWordExcel.do',
      data: data,
      loading: true
    });
  }
   // 巡视反馈意见整改处置情况汇总表一----导出
 export function inspectionExcelDiy(data) {
    return request({
      method: 'post',
      url: 'inspection/excelDiy.do',
      data: data,
      loading: true
    });
  }
  // 巡视反馈意见整改处置情况汇总表二----导出
 export function inspectionExportWordExcelTwo(data) {
    return request({
      method: 'post',
      url: 'inspection/exportWordExcelTwo.do',
      data: data,
      loading: true
    });
  }
  // 巡视反馈意见整改处置情况汇总表二----导出
 export function inspectionExcelDiyTwo(data) {
    return request({
      method: 'post',
      url: 'inspection/excelDiyTwo.do',
      data: data,
      loading: true
    });
  }


  // 整改情况上报--上传附件成功后将文件的信息更新到整改情况中
 export function rectificationSituationSaveFileInfo(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/saveFileInfo.do',
      data: data,
      loading: true
    });
  }

   // 新建呈批拦截判定
 export function sendBatchClickFormOpinionCheck(data) {
    return request({
      method: 'post',
      url: 'sendBatch/clickFormOpinionCheck.do',
      data: data,
      loading: true
    });
  }

   // 整改方案--一键删除接口
 export function questionDeleteByInspectionId(data) {
    return request({
      method: 'post',
      url: 'question/deleteByInspectionId.do',
      data: data,
      loading: true
    });
  }
    // 整改方案--撤回接口
 export function inspectionChangeStatusForRecall(data) {
    return request({
      method: 'post',
      url: 'inspection/changeStatusForRecall.do',
      data: data,
      loading: true
    });
  }
//   整改情况上报--填报 new
export function rectificationSituationSearchOrCreateReport(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/searchOrCreateReport.do',
      data: data,
      loading: true
    });
  }

  //   首页--柱状图数据
export function clueCountQueryUnitCount(data) {
    return request({
      method: 'post',
      url: 'clueCount/queryUnitCount.do',
      data: data,
      loading: true
    });
  }


  //   首页--告警数据
export function inspectionQueryInspectionOverdue(data) {
    return request({
      method: 'post',
      url: 'inspection/queryInspectionOverdue.do',
      data: data,
      loading: true
    });
  }

    //   首页--查询待办已办
export function sendBatchNumberStatistics(data) {
    return request({
      method: 'post',
      url: 'sendBatch/numberStatistics.do',
      data: data,
      loading: false
    });
  }

//     //   首页--查询柱状图数据
// export function statisticalDataRateCalculation(data) {
//     return request({
//       method: 'post',
//       url: 'statisticalData/rateCalculation.do',
//       data: data,
//       loading: true,
//     });
//   }
    // 四清单问题标签查询
export function queryCustom(data) {
    return request({
      method: 'post',
      url: 'Custom/queryCustom',
      data: data,
      loading: true
    });
  }
    // 四清单问题标签保存
export function questionInsertLabel(data) {
    return request({
      method: 'post',
      url: 'question/addCustomByQuestionId',
      data: data,
      loading: true
    });
  }
    // 四清单措施标签保存
export function rectificationSituationInsertLabel(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/insertLabel',
      data: data,
      loading: true
    });
  }
    // 查四清单问题措施内容
export function queryQuestionByInspectionOId(data) {
    return request({
      method: 'post',
      url: 'inspection/queryQuestionByInspectionOId.do',
      data: data,
      loading: true
    });
  }
    // 查存的问题标签内容
export function questionQueryLabel(data) {
    return request({
      method: 'post',
      url: 'question/queryLabel.do',
      data: data,
      loading: true
    });
  }
    // 查存的措施情况标签内容
export function rectificationSituationQueryLabel(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/queryLabel.do',
      data: data,
      loading: true
    });
  }
    // 整改情况公开的审核
export function auditOpenEnd(data) {
    return request({
      method: 'post',
      url: 'sendBatch/auditOpenEnd.do',
      data: data,
      loading: true
    });
  }


     // 查四清单问题措施内容
export function statisticalDataGetInspChart(data) {
    return request({
      method: 'post',
      url: 'statisticalData/getInspChart.do',
      data: data,
      loading: true
    });
  }
  // 问题编辑查询
export function queryQuestionInfoById(data) {
    return request({
      method: 'post',
      url: 'question/queryQuestionInfoById.do',
      data: data,
      loading: true
    });
  }
  // 问题编辑保存
export function savePersonByQuestion(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/savePersonByQuestion.do',
      data: data,
      loading: true
    });
  }
  // 联审意见保存
export function saveJointAuditByQuestion(data) {
    return request({
      method: 'post',
      url: 'question/saveJointAuditByQuestion.do',
      data: data,
      loading: true
    });
  }
  // 根据巡视单位类型查询单位名称
export function getDeptNameList(data) {
  return request({
    method: 'post',
    url: 'statisticalData/getDeptNameList.do',
    data: data,
    loading: false
  });
}
// 根据巡视单位类型查询单位类型
export function getDeptTypeList(data) {
  return request({
    method: 'post',
    url: 'branchAboral/queryInspectionUnitTypeByOrgInnerCode.do',
    data: data,
    loading: false
  });
}
  // 呈批单结束接口
export function saveOpinionByUpAuditId(data) {
  return request({
    method: 'post',
    url: 'sendBatch/saveOpinionByUpAuditId.do',
    data: data,
    loading: true
  });
}
  // 查询审核历史
export function queryLogByInspectionId(data) {
  return request({
    method: 'post',
    url: 'sendBatch/queryLogByInspectionId.do',
    data: data,
    loading: true
  });
}
  // 查询下面列表里面的审核历史
export function queryLogByQuestionId(data) {
  return request({
    method: 'post',
    url: 'sendBatch/queryLogByQuestionId.do',
    data: data,
    loading: true
  });
}

// 查询
export function queryfeedbackByInspectionId(data) {
    return request({
      method: 'post',
      url: 'sendBatch/queryfeedbackByInspectionId.do',
      data: data,
      loading: true
    });
}
// 整改进展情况巡视审核历史查呈批单
export function queryBatchLogByInspectionId(data) {
    return request({
      method: 'post',
      url: 'sendBatch/queryBatchLogByInspectionId.do',
      data: data,
      loading: true
    });
}
// 新增巡视人员信息
export function xsTeamPersonAdd(data) {
    return request({
      method: 'post',
      url: 'XsTeamPerson/addPerson.do',
      data: data,
      loading: true
    });
}

// 查询巡视人员信息
export function xsTeamPersonQuery(data) {
    return request({
      method: 'post',
      url: 'XsTeamPerson/query.do',
      data: data,
      loading: true
    });
}

// 删除巡视人员信息
export function xsTeamPersonDelete(data) {
    return request({
      method: 'post',
      url: 'XsTeamPerson/deletePerson.do',
      data: data,
      loading: true
    });
}
// 签收联审结果
export function acceptfeedbackWordByUpFeedbackId(data) {
    return request({
      method: 'post',
      url: 'sendBatch/acceptfeedbackWordByUpFeedbackId',
      data: data,
      loading: true
    });
}
// 查询自定义标签
export function customQueryCustom(data) {
    return request({
      method: 'post',
      url: 'Custom/queryCustom.do',
      data: data,
      loading: true
    });
}
// 呈批单退回
export function backBatchForm(data) {
    return request({
      method: 'post',
      url: 'sendBatch/backBatchForm.do',
      data: data,
      loading: true
    });
}
// 呈批单撤回
export function withdrawBatchForm(data) {
    return request({
      method: 'post',
      url: 'sendBatch/withdrawBatchForm.do',
      data: data,
      loading: true
    });
}
// 整改情况上报撤回
export function withdrawUpAuditRfstByQuestionId(data) {
    return request({
      method: 'post',
      url: 'rectificationSituation/withdrawUpAuditRfstByQuestionId.do',
      data: data,
      loading: true
    });
}
// 查工作桌面呈批单的待办已办数
export function numberBatchStatistics(data) {
    return request({
      method: 'post',
      url: 'sendBatch/numberBatchStatistics.do',
      data: data,
      loading: true
    });
}
// 查首页巡视流程办理数据
export function queryWaitInspectionByDesc(data) {
    return request({
      method: 'post',
      url: 'sendBatch/queryWaitInspectionByDesc.do',
      data: data,
      loading: true
    });
}
// 整改措施上报
export function swInsertUpReport(data) {
    return request({
      method: 'post',
      url: 'upReport/swInsertUpReport.do',
      data: data,
      loading: true
    });
}
// 整改措施查看历史
export function queryBySwHistory(data) {
    return request({
      method: 'post',
      url: 'upReport/queryBySwHistory.do',
      data: data,
      loading: true
    });
}
// 整改情况是否会商
export function changeToJointAudit(data) {
    return request({
      method: 'post',
      url: 'question/changeToJointAudit.do',
      data: data,
      loading: true
    });
}
// 整改方案是否会商
export function changeToJointAuditByInspId(data) {
    return request({
      method: 'post',
      url: 'question/changeToJointAuditByInspId.do',
      data: data,
      loading: true
    });
}
// 整改方案导出
export function exportFourListExcel(data) {
    return request({
      method: 'post',
      url: 'inspection/exportFourListExcel.do',
      data: data,
      loading: true
    });
}
// 整改情况导出
export function exportProgressListExcel(data) {
    return request({
        method: 'post',
        url: 'inspection/exportProgressListExcel.do',
        data: data,
        loading: true
    });
}
// 持续整改导出
export function exportContinuousImprovementListExcel(data) {
    return request({
        method: 'post',
        url: 'inspection/exportContinuousImprovementListExcel.do',
        data: data,
        loading: true
    });
}
// 生成联审意见
export function createJointAuditOpinionByInspId(data) {
    return request({
      method: 'post',
      url: 'question/createJointAuditOpinionByInspId.do',
      data: data,
      loading: true
    });
}
// 整改报告直接审核通过
export function auditReportByInspectionId(data) {
    return request({
      method: 'post',
      url: 'sendBatch/auditReportByInspectionId.do',
      data: data,
      loading: true
    });
}

// 整改情况直接通过
export function directStatusByrfstId(data) {
    return request({
        method: 'post',
        url: '/inspection/directStatusByrfstId.do',
        data: data,
        loading: true
    });
}

// 新增任务关系轮次被巡视单位查询是否使用
export function queryBySelectMsg(data) {
    return request({
        method: 'post',
        url: 'branchAboral/queryBySelectMsg.do',
        data: data,
        loading: true
    });
}

// 查询时间
export function queryDeadline(data) {
    return request({
        method: 'get',
        url: 'branchAboral/queryDeadline.do',
        data: data,
        loading: true
    });
}

// 保存时间
export function updateDeadline(data) {
    return request({
        method: 'post',
        url: 'branchAboral/updateDeadline.do',
        data: data,
        loading: true
    });
}

// Excel导出
export function exportUnitContactPersonExcel(data) {
    return request({
        method: 'post',
        url: 'excel/exportUnitContactPersonExcel.do',
        data: data,
        loading: true
    });
}

// 线下呈批文件
export function getOfflineFile(data) {
    return request({
        method: 'post',
        url: 'inspection/getOfflineFile.do',
        data: data,
        loading: true
    });
}

// 整改公开签收
export function publicAnnouncementReceipt(data) {
    return request({
        method: 'post',
        url: 'sendBatch/publicAnnouncementReceipt.do',
        data: data,
        loading: true
    });
}

// 获取修改问题
export function getUnApprovedOpinion(data) {
    return request({
        method: 'post',
        url: 'inspection/getUnApprovedOpinion.do',
        data: data,
        loading: true
    });
}

// 签收修改问题
export function signUnApprovedOpinion(data) {
    return request({
        method: 'post',
        url: 'inspection/signUnApprovedOpinion.do',
        data: data,
        loading: true
    });
}

// 删除反馈意见
export function deleteLocalFile(data) {
    return request({
        method: 'post',
        url: 'inspection/deleteLocalFile.do',
        data: data,
        loading: true
    });
}

// 整改方案签收
export function signRectificationReport(data) {
    return request({
        method: 'post',
        url: 'inspection/signRectificationReport.do',
        data: data,
        loading: true
    });
}



// WEBPACK FOOTER //
// ./src/api/IntegrityArchives.js